// src/context/AuthContext.js
import { createContext, useState, useEffect, useCallback } from "react";
import { jwtDecode } from "jwt-decode";
import api from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ تابع برای دریافت اطلاعات کاربر
  const fetchProfile = useCallback(async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.post("/auth/profile");
      setUser(data);
      setRole(data.role);
      localStorage.setItem("role", data.role);
    } catch (err) {
      console.error("خطا در واکشی پروفایل:", err);
      logout(); // توکن خراب → خروج
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ تابع ورود (login)
  const login = async (credentials) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", credentials);
      const token = data.access_token;

      // ذخیره توکن
      localStorage.setItem("access_token", token);
      api.defaults.headers.common.Authorization = `Bearer ${token}`;

      // 📌 به جای استفاده از decoded.sub، پروفایل واقعی رو بگیر
      await fetchProfile();

      setLoading(false);
      return true;

      /*const decoded = jwtDecode(data.access_token);
      localStorage.setItem("role", decoded.role || "USER");
      setUser(decoded.sub);
      setRole(decoded.role || "USER");

      setLoading(false);
      return decoded;*/
    } catch (err) {
      setLoading(false);
      throw err;
    }
  };

  // ✅ تابع خروج (logout)
  const logout = useCallback(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("role");
    setUser(null);
    setRole(null);
  }, []);

  // ✅ دریافت پروفایل در اولین بار
  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        role,
        loading,
        login,
        logout,
        fetchProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
